import { render } from "./GuiidePlus.vue?vue&type=template&id=10570d02&ts=true"
import script from "./GuiidePlus.vue?vue&type=script&lang=ts"
export * from "./GuiidePlus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__